module.exports = __webpack_public_path__ + "162f3aeb160dee95809bce8df2aaac42.svg";